import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'length'
})
export class LengthPipe implements PipeTransform {
  transform(array: any[]) {
    // console.log(`Length object: ${JSON.stringify(array)}`);
    return Array.isArray(array) ? array.length : 0;
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/length.pipe.ts